// @mui
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
// auth
import { useAuthContext } from 'src/auth/hooks';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
import { ImpersonationBanner, IMPERSONATION_BANNER_HEIGHT } from 'src/components/student-impersonation';
//
import Main from './main';
import Header from './header';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';
import NavHorizontal from './nav-horizontal';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  // Keep the page's last content clear of the fixed view-as-student bar
  const { impersonatedBy } = useAuthContext();

  const reserveBottom = impersonatedBy ? IMPERSONATION_BANNER_HEIGHT : 0;

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;

  if (isHorizontal) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        {lgUp ? renderHorizontal : renderNavVertical}

        <Main reserveBottom={reserveBottom}>{children}</Main>

        <ImpersonationBanner />
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main reserveBottom={reserveBottom}>{children}</Main>
        </Box>

        <ImpersonationBanner />
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main reserveBottom={reserveBottom}>{children}</Main>
      </Box>

      <ImpersonationBanner />
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
